export default class UrlHelper {
	static getParams(url: string): any {
		const params = Object.create(null)

		new URLSearchParams((url || '').trim().replace(/^[?#&]/, '')).forEach((value, key) => {
			if (key in params) {
				params[key] = [].concat(params[key], value)
			} else {
				params[key] = value
			}
		})

		return params
	}

	static isDataUrl(url: string) {
		const regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
		return !!url.match(regex);
	}
}